import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_DappBlock = _resolveComponent("DappBlock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, { text: _ctx.listName }, null, 8, ["text"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dapps, (dapp) => {
      return (_openBlock(), _createElementBlock("div", {
        key: dapp.Id
      }, [
        (!('dapp' in dapp))
          ? (_openBlock(), _createBlock(_component_DappBlock, {
              key: 0,
              dapp: dapp
            }, null, 8, ["dapp"]))
          : (_openBlock(), _createBlock(_component_DappBlock, {
              key: 1,
              dapp: dapp.dapp,
              localState: dapp
            }, null, 8, ["dapp", "localState"]))
      ]))
    }), 128))
  ], 64))
}